import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './PostItMessage.module.css';

const postItMessage = (props) => {
  const containerClasses = [classes.PostIt];
  if (props.type) containerClasses.push(classes[props.type]);
  return (
    <div style={{ left: props.positionLeft, top: props.positionTop }} className={containerClasses.join(' ')}>
      <FontAwesomeIcon className={classes.Close} onClick={props.close} icon="times" />
      {props.message}
    </div>
  );
};

export default postItMessage;
